export default __webpack_public_path__ + "static/media/pdb.8750f8df.jpg";